<template>
<div>
    <Breadcrumbs main="Admin" submain="Portfolio" title="Bio" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12" v-if="!loading && !error">
                <px-card>
                    <div slot="with-padding">
                        <div class="form theme-form">
                            <!-- <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Title</label>
                                        <input class="form-control" type="text" placeholder="Enter title" v-model="bio.title">
                                    </div>
                                </div>
                            </div> -->
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>In English</label>
                                        <vue-editor v-model="bio.english_bio"></vue-editor>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>In Bangla</label>
                                        <vue-editor v-model="bio.bangla_bio"></vue-editor>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group mb-0">

                                        <button @click="onSubmit()" class="btn btn-primary mr-3">Update Bio</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </px-card>
            </div>

            <div class="col-sm-12" v-else>
                <div class="card">
                    <Loader />
                </div>
            </div>
        </div>
    </div>

    <!-- Container-fluid Ends-->
</div>
</template>

    
<script>
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import Loader from '../loader/loader.vue';
import {
    VueEditor
} from "vue2-editor";
import {
    mapState
} from 'vuex';

export default {
    components: {
        Loader,
        VueEditor
    },

    data() {
        return {
            bio: {
                title: 'Academician & Researcher',
                bangla_bio: '',
                english_bio: '',

            }

        };
    },

    watch: {
        details(oldValue, newValue) {
            this.bio.title = this.details.title ? this.details.title : "";
            this.bio.bangla_bio = this.details.bangla_bio ? this.details.bangla_bio : "";
            this.bio.english_bio = this.details.english_bio ? this.details.english_bio : "";

        },
    },

    mounted() {
        this.$store.dispatch("bio/fetchBioDetails")
    },

    computed: {
        ...mapState({
            details: state => state.bio.bioDetail,
            loading: state => state.bio.submitLoading,
            error: state => state.bio.submitError,
        })

    },
    methods: {
        onSubmit() {

            this.$store.dispatch("bio/addBio", {
                bio: this.bio,
            }).then(response => {
                if (response.code == 200) {
                    Object.keys(this.bio).forEach(key => {
                        this.bio[key] = '';
                    });

                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

    }
};
</script>
